<template>
  <div 
    id="water_supplied_ship"
    class="water_supplied"
  >
    <div 
      v-if="receivedData"
      class="water_supplied-item"
    >
      <CastomGraphic
          :received-data="receivedData[0]"
          graph-type="bar"
          index-axis="y"
          :id="'water_supplied_ship-1'"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
          :stacked="false"
      />
    </div> 
    <div 
      v-if="receivedData"
      class="water_supplied-item"
    >
      <TabsCustomGraphic
          :received-data="receivedData[1]"
          :id="'water_supplied_ship-2'"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
          :stacked="false"
      />
    </div> 
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'WaterSupplied',
  
  components: {
    CastomGraphic: () => import('@/components/graph/CastomGraphic.vue'),
    TabsCustomGraphic: () => import('@/components/graph/TabsCustomGraphic.vue'),
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'water_supplied',
      cloneElementId: 'water_supplied_ship'
    }
  },

  mounted() {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '69,70,71').then((response) => {
        this.receivedData = []
        this.receivedData[0] = response.data[0]
        this.receivedData[1] = response.data.slice(1)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .water_supplied-item {
    margin-top: 20px;
  }
</style>